import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './overlay-spinning.component.html',
  styleUrls: ['./overlay-spinning.component.scss']
})
export class MmOverlaySpinningComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
